import style from 'containers/MyHealth/components/MyHealthResultsContext/styles'
const themeStyles = colors => {
  const styles = {
    ...style(colors),
    testContainer: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1
    },
    learnMoreButton: {
      marginLeft: 0
    },
    text: {
      flexBasis: 'auto',
      width: '25%',
      margin: 0
    }
  }
  styles.textMiddle = { ...styles.text, width: '30%', padding: '10px 0' }
  styles.textLeft = { ...styles.text, flex: 1, overflowWrap: 'break-word' }
  styles.textRight = { ...styles.text, padding: '10px 0 10px 0', textWrap: 'nowrap' }
  return styles
}
export default themeStyles
